<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <div class="d-flex">
          <div class="side-frame-success"></div>
          <div class="title">{{ $l('table_title_operate') || '补货翻单按运营统计' }}</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      searchFocus: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', { ...this.form })
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin: 3px 0 0 0;
}
.title {
  font-size: 14px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
